module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "bg1"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0010-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0011-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thirty years after SOG’s dissolution, the top secret unit’s existence was acknowledged with a Presidential Unit Citation, America’s highest such award. More than 200 veterans of SOG’s secret war assembled at Fort Bragg, North Carolina, on 1 April 2001, for the Citation’s formal presentation, which hailed their “officially denied operations” and “unacknowledged sacrifices.”")])]), _vm._v(" "), _c('p', {
    staticClass: "capa"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As of this writing, the Vietnamese government has refused to admit capturing any of SOG’s 57 MIAs, though some remains have been recovered from downed aircraft sites.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1d5a58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Front.vue
// module id = 81
// module chunks = 0